<template lang="pug">
.select-container
  .select-tags(:class="{'error': !!isValid || inputUnvalid}",
    @click.stop="onClick($event)")
    span.placeholder.error(v-show="unvalidMsg") {{unvalidMsg}}
    span.placeholder(
      v-show="placeholderShow"
      ) {{placeholder}}
    span.tag-item(v-for="tag,index in tags",
      :class="{'tag-padding': disabled}")
      | {{tag.label}}
      i.fa.fa-times(@click="removeTag(index)",
        v-show="!disabled")
    input(type="text",
        @input="inputUnvalid = false",
        v-show="isSearched && droplistShow && tags.length < maxlength",
        @keyup.enter.stop.prevent="addInputTag",
        v-model.trim="searchValue"
      )
  span.select-dropdown-list
    ul.select-droplist(
      v-show="droplistShow",
      @mousewheel="onMousewheel($event)")
      li.select-droplist-item(v-show="optionList.length == 0")
        |  暂无相关数据
      li.select-droplist-item(v-for="item,index in optionList",
          :class="{'not-allowed': tags.length >= maxlength && !item.checked}",
          @click.prevent.stop="updateSelectItem(item, index)"
        )
        v-checkbox(v-model="item.checked",
            :disabled="tags.length >= maxlength && !item.checked",
            @change.native="updateSelectItem(item, index)"
          )
        span.text(:title="item.label") {{item.label}}
    div.warning(
      v-show="droplistShow && optionList.length >= 50"
      )
      span.warning-search(
          v-if="this.searchValue != ''"
        ) 搜索结果过多，请提高搜索精度
      span.warning-default(
          v-else
        ) 内容过多未全部列举，请搜索关键信息

</template>
<script>
/* global _ */
export default {
  props: {
    valid: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    isSearched: Boolean,
    disabled: Boolean,
    dim: {
      type: Object,
      default () {
        return {}
      }
    },
    inputPattern: String,
    api: String,
    placeholder: String,
    value: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      isValid: false,
      inputUnvalid: false,
      searchValue: '',
      selectEl: '',
      optionList: [],
      tags: [],
      unvalidMsg: '',
      droplistShow: false
    }
  },
  created () {
    this.isValid = this.valid
    if (this.value !== '') {
      _.map(this.value.split(','), item => {
        this.tags.push({
          label: item,
          value: item
        })
      })
    }
    this.getDimValues()
  },
  watch: {
    valid (newVal, oldVal) {
      this.isValid = newVal
    },
    searchValue () {
      this.getDimValues()
    },
    dim: {
      handler (newVal, oldVal) {
        this.unvalidMsg = ''
        if (!_.isEmpty(newVal)) {
          this.getDimValues()
        }
      },
      deep: true
    },
    value (newVal, oldVal) {
      if (newVal === oldVal || newVal === _.map(this.tags, item => item.label).join(',')) return
      const newTags = []
      if (this.value !== '') {
        _.map(this.value.split(','), item => {
          newTags.push({
            label: item,
            value: item
          })
        })
      } else {
        this.getDimValues()
      }
      this.tags = newTags
    }
  },
  computed: {
    placeholderShow () {
      return !this.unvalidMsg && !this.droplistShow && this.tags.length === 0
    }
  },
  mounted () {
    this.selectEl = document.querySelector('.select-dropdown-list')
    document.body.appendChild(this.selectEl)
    this.selectEl.style.cssText = this.getStyle()
    document.addEventListener('click', this.close, true)
    window.addEventListener('resize', this.resize, false)
    window.addEventListener('scroll', this.resize, true)
  },
  methods: {
    addInputTag (e) {
      const reg = new RegExp(this.inputPattern)
      if (this.searchValue === '' || !reg.test(this.searchValue)) {
        this.inputUnvalid = true
        return
      }
      this.tags.push({
        label: this.searchValue,
        value: 'na'
      })
      this.searchValue = ''
      this.$emit('input', _.map(this.tags, item => item.label).join(','))
      this.$emit('change', this.tags)
      this.resize()
    },
    onMousewheel (e) {
      const elem = e.currentTarget
      const scrollTop = elem.scrollTop
      const dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0

      if (dir === 'up' && scrollTop <= 0) {
        return e.preventDefault()
      }

      if (dir === 'down' && (elem.clientHeight + scrollTop) === elem.scrollHeight) {
        return e.preventDefault()
      }
    },
    getDimValues () {
      if (_.isEmpty(this.dim)) return
      const valuePromise = this.$http.get(this.api, {
        params: {
          domainId: this.$store.state.domainId,
          dim: this.dim.dim,
          dim_table: this.dim.dim_table,
          dim_val: this.searchValue
        }
      })
      this.$store.dispatch('VUE_HTTP', [valuePromise])
        .then(res => {
          if (!res.errno) {
            const optionList = []
            _.map(res.list, item => {
              optionList.push({
                label: item.dim_val,
                value: _.has(item, 'dim_id') ? item.dim_id : 'na',
                checked: !_.isEmpty(_.find(this.tags, {label: item.dim_val}))
              })
            })
            if (res.is_trans) {
              this.inputUnvalid = true
              this.unvalidMsg = res.msg
            }
            this.$nextTick(() => {
              this.optionList = optionList
            })
          }
        })
    },
    onClick (e) {
      if (this.disabled || this.unvalidMsg) return
      this.isValid = false
      this.droplistShow = true
      const searchInput = this.$el.querySelector('input')
      this.$nextTick(() => {
        this.resize()
        searchInput && searchInput.focus()
      })
    },
    getStyle () {
      const clientRect = this.$el.getBoundingClientRect()
      const windowH = window.innerHeight
      const marginTop = 2
      const maxHeight = 275
      const scrollHeight = document.body.scrollWidth > window.innerWidth ? 20 : 0
      const droplistHeight = this.optionList.length * 30 > maxHeight ? maxHeight : this.optionList * 30
      const extendHeight = this.optionList.length === 50 ? 30 : 0
      const defaultTop = clientRect.top + clientRect.height + marginTop + window.pageYOffset
      const clientHeight = clientRect.height + marginTop

      const clientY = clientRect.y
      const compTop = windowH - droplistHeight - scrollHeight - extendHeight
      const left = clientRect.left + window.pageXOffset
      const top = droplistHeight + extendHeight + clientHeight + clientY + scrollHeight > windowH ? compTop : defaultTop
      return `
        position: absolute;
        top: ${top}px;
        left: ${left}px;
        z-index: 9;
      `
    },
    resize () {
      this.$nextTick(() => {
        this.selectEl.style.cssText = this.getStyle()
      })
    },
    removeTag (index) {
      const currentTag = _.find(this.optionList, {label: this.tags[index].label})
      if (currentTag) {
        this.$set(currentTag, 'checked', false)
        this.$set(this.tags[index], 'checked', false)
      }
      this.tags.splice(index, 1)
      this.$emit('input', _.map(this.tags, item => item.label).join(','))
      this.$emit('change', this.tags)
      this.resize()
    },
    updateSelectItem (item, index) {
      this.droplistShow = true
      if (!item.checked && this.tags.length >= this.maxlength) {
        this.$set(item, 'checked', false)
        return
      }
      this.$set(item, 'checked', !item.checked)
      if (item.checked) {
        this.tags.push(item)
      } else {
        this.tags.splice(_.findIndex(this.tags, item), 1)
      }
      this.resize()
      this.$emit('input', _.map(this.tags, item => item.label).join(','))
      this.$emit('change', this.tags)
    },
    close (e) {
      const isInContainer = this.$el.contains(e.target)
      if (!isInContainer) {
        this.droplistShow = false
        this.inputUnvalid = false
        this.searchValue = ''
      }
    }
  },
  destroyed () {
    document.removeEventListener('click', this.close, true)
    window.removeEventListener('resize', this.resize, false)
    window.removeEventListener('scroll', this.resize, true)
  }
}
</script>
<style scoped>
@import '../css/base/variables.css';
.select-container {
    cursor: pointer;
    display: inline-block;
    width: 240px;
    background-color: #fff;
    line-height: 20px;
    margin: 0 5px;
    vertical-align: top;
    margin-top: 2px;
    .select-tags {
      min-height: 28px;
      border: 1px solid #dadfe6;
      max-height: 80px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-thumb {
          background: #ced3d9;
          border-radius: 10px;
          border-radius: 30px;
      }
      &::-webkit-scrollbar-track {
          background: #eaeced;
      }
      &.error {
        border-color: #E5675C;
      }
    }
    input {
      width: auto;
      border: 0;
      height: 24px;
      box-shadow: none;
      vertical-align: baseline;
      float: left;
    }
}
.select-droplist {
    width: 240px;
    box-shadow: 0 0 5px #dadfe6;
    list-style: none;
    max-height: 274px;
    overflow-y: auto;
    border: 1px solid #DADFE6;
    border-top: 0;
    background-color: #fff;
    box-sizing: border-box;
    z-index: 99;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ced3d9;
        border-radius: 10px;
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #eaeced;
    }
}
.select-droplist-item {
    border-top: 1px solid #dadfe6;
    line-height: 28px;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    text-align: left;
    cursor: pointer;
    line-height: 28px;
    padding: 0 5px 0 8px;
    color: #596980;
    font-size: 12px;
    font-weight: normal;
    max-width: 235px;
    span.text {
      position: relative;
    }
    .checkbox {
      margin-right: 5px;
    }
    &.active,
    &:hover {
      background-color: #F5F8FB;
      font-weight: bold;
    }
}
.tag-item {
    display: inline-block;
    float: left;
    border: 1px solid #8fa8cc;
    background: #8fa8cc;
    padding-left: 5px;
    margin: 2px;
    color: #fff;
    position: relative;
    padding-right: 15px;
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .fa {
        width: 10px;
        line-height: 10px;
        background: #f5f8fb;
        color: #8fa8cc;
        text-align: center;
        position: absolute;
        top: 1px;
        right: 1px;
    }
}
.tag-padding {
  padding-right: 5px;
}
.placeholder {
  color: #757575;
  vertical-align: -webkit-baseline-middle;
  padding: 0 5px;
}
.not-allowed {
  color: var(--Slightgrey);
  cursor: not-allowed;
  &:hover {
    background: #fff;
    font-weight: normal;
  }
}
.error {
  color: red;
}
.warning {
    background: #fff;
    padding: 5px 10px;
    text-align: center;
    color: #596980;
}
.warning-search {
    color: #ef9b6d;
}
</style>



// WEBPACK FOOTER //
// mutilselect.vue?4aaaaffe